import React, { useEffect, useState, useMemo } from "react";
import apiService, { handleError } from "../Common/ApiCommon/ApiService";
import icons from "../../assets/images/constantIcons";
import { useNavigate } from "react-router-dom";
import Pagination from "../Common/Pagination"; // Assuming this is same Pagination component

const getInitials = (text = "") => {
  const words = text.trim().split(" ");
  const initials = words
    .filter(Boolean)
    .slice(0, 3)
    .map((word) => word[0])
    .join("");
  return initials.toUpperCase();
};

const ViewAllNotification = () => {
  const [notification, setNotification] = useState([]);
  const [loading, setLoading] = useState(false);
  const [marking, setMarking] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const navigate = useNavigate();

  const fetchAllNotification = async () => {
    setLoading(true);
    try {
      const response = await apiService.get(`/notifications`);
      setNotification(response.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const markAllAsRead = async () => {
    setMarking(true);
    try {
      await apiService.patch(`/notifications/mark_all_as_read`);
      fetchAllNotification();
    } catch (error) {
      handleError(error);
    } finally {
      setMarking(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      await apiService.patch(`/notifications/mark_as_read?id=${id}`);
      setNotification((prev) =>
        prev.map((notif) =>
          notif.id === id ? { ...notif, read: true } : notif
        )
      );
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    fetchAllNotification();
  }, []);

  // ⬇️ Pagination logic
  const totalRows = notification.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = useMemo(
    () => notification.slice(indexOfFirstRow, indexOfLastRow),
    [notification, indexOfFirstRow, indexOfLastRow]
  );

  const handlePageChange = (newPage) => setCurrentPage(newPage);
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); // Reset to page 1 when page size changes
  };

  return (
    <div className="p-4 flex flex-col">
      {/* Header */}
      <div className="flex justify-between mb-5">
        <h1 className="main_heading text-2xl xl:text-[30px] flex gap-3 items-center">
          <icons.IoMdArrowRoundBack
            onClick={() => navigate(-1)}
            className="cursor-pointer text-green text-2xl font-extrabold"
          />
          <p>All notification</p>
        </h1>
        <h1
          onClick={markAllAsRead}
          className={`flex items-center gap-2 border px-2 py-1 rounded-md bg-white cursor-pointer hover:bg-slate-50 ${
            marking ? "opacity-60 pointer-events-none" : ""
          }`}
        >
          <icons.TbMailCheck className="text-lg font-semibold" />
          <p className="text-sm font-medium">
            {marking ? "Marking..." : "Mark all as read"}
          </p>
        </h1>
      </div>

      {/* Notification List */}
      {loading ? (
        <p className="text-center text-sm text-gray-500">
          Loading notifications...
        </p>
      ) : (
        <div className="flex flex-col gap-3 mb-20">
          {" "}
          {/* Leave space for pagination */}
          {currentRows.map((notif) => (
            <div
              key={notif.id}
              onClick={() => markAsRead(notif.id)}
              className={`cursor-pointer w-full rounded-xl border-t flex justify-between items-center gap-3 md:gap-8 px-4 py-2 ${
                notif.read
                  ? "bg-white border-gray-200"
                  : "bg-gray-200 border-green-400"
              }`}
            >
              <div className="flex items-center gap-5 w-[70%] sm:w-[80%]">
                <div className="relative w-[36px] h-[36px] rounded-full bg-green50 flex items-center justify-center text-green800 font-semibold text-sm uppercase overflow-hidden">
                  {notif.icon ? (
                    <img
                      src={notif.icon}
                      alt="icon"
                      className="w-[20px] h-[20px] object-contain"
                    />
                  ) : (
                    getInitials(notif.title)
                  )}
                  {!notif.read && (
                    <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full" />
                  )}
                </div>
                <div>
                  <h4 className="text-sm font-medium text-G800">
                    {notif.title}
                  </h4>
                  <p className="text-G80 font-normal text-[12px]">
                    {notif.body}
                  </p>
                </div>
              </div>
              <div className="flex flex-col xs:flex-row justify-between items-center gap-2 xs:gap-4 w-[30%] sm:w-[20%]">
                <span className="text-G80 font-medium text-sm">
                  {notif.time}
                </span>
                <span className="bg-G80 text-white hover:bg-red hover:bg-opacity-80 hover:text-white w-8 h-8 rounded-full flex justify-center items-center">
                  <icons.IoClose />
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      <Pagination
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

//       <Pagination
//         currentPage={currentPage}
//         rowsPerPage={rowsPerPage}
//         totalRows={totalRows}
//         onPageChange={handlePageChange}
//         onRowsPerPageChange={handleRowsPerPageChange}
//       />
//     </div>
//   );
// };

export default ViewAllNotification;
